import React from 'react';

import useLoader, { getTexture } from '@/game/useLoader';

type Anchor = number | { x: number; y: number } | [number, number];

function toAnchor(anchor: Anchor): number | { x: number; y: number } {
  if (Array.isArray(anchor)) {
    return { x: anchor[0], y: anchor[1] };
  }
  return anchor;
}

export type Props = {
  anchor: Anchor;
  positionV: 'top' | 'bottom';
  positionH: 'left' | 'right';
  x?: number;
  y?: number;
};

const BorderCorner = ({
  anchor,
  positionV,
  positionH,
  x = 0,
  y = 0,
}: Props) => {
  const { loaded } = useLoader();

  if (!loaded) return null;

  const texture = getTexture(`corner-${positionV}-${positionH}`);

  return (
    <pixiContainer>
      <pixiSprite anchor={toAnchor(anchor)} texture={texture} x={x} y={y} />
    </pixiContainer>
  );
};

export default BorderCorner;
